import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import WarningIcon from "@material-ui/icons/Warning";

const styles = theme => ({

  root: {
    width: "100%",
    maxWidth: 1000,
    minHeight: 110,
    margin: "14px auto",
    borderRadius: 24,
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.12)",
    border: "2px solid #E0B04B",
    cursor: "pointer",
    transition: "all 0.2s ease",

    "&:hover": {
      transform: "scale(1.01)",
      boxShadow: "0px 12px 28px rgba(0, 0, 0, 0.18)"
    }
  },

  left: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },

  avatar: {
    width: 60,
    height: 60,
    borderRadius: "50%",
    objectFit: "cover",
  },

  info: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },

  nome: {
    fontWeight: 700,
    fontSize: 18,
    color: "#C68A00",
  },

  chipsRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },

  chipRestricao: {
    border: "1px solid #C68A00",
    color: "#C68A00",
    backgroundColor: "transparent",
    fontWeight: 600,
    fontSize: 12,
  },

  chipPresente: {
    backgroundColor: "#DFF5F0",
    color: "#18A689",
    fontWeight: 600,
    fontSize: 12,
  },

  idade: {
    fontWeight: 600,
    color: "#666",
  },

  right: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    minWidth: 250,
  },

  restricaoItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: "#6F7C8E",
    fontWeight: 500,
    fontSize: 14,
  }

});

class AlunoRestricaoCard extends React.Component {

  render() {

    const {
      classes,
      nome,
      idade,
      presente,
      foto,
      restricoes,
      onClick
    } = this.props;

    return (
      <Paper elevation={0} className={classes.root} onClick={onClick}>

        {/* ESQUERDA */}
        <div className={classes.left}>

          <img
            src={foto}
            alt={nome}
            className={classes.avatar}
          />

          <div className={classes.info}>
            <Typography className={classes.nome}>
              {nome}
            </Typography>

            <div className={classes.chipsRow}>
              <Chip
                icon={<WarningIcon style={{ fontSize: 16 }} />}
                label={`${restricoes.length} restrições alimentares`}
                className={classes.chipRestricao}
                size="small"
              />

              {presente && (
                <Chip
                  label="Presente"
                  className={classes.chipPresente}
                  size="small"
                />
              )}

              <Typography className={classes.idade}>
                {idade} anos
              </Typography>
            </div>
          </div>

        </div>

        {/* DIREITA */}
        <div className={classes.right}>
          {restricoes.map((item, index) => (
            <div key={index} className={classes.restricaoItem}>
              <WarningIcon style={{ fontSize: 16, color: "#C68A00" }} />
              {item}
            </div>
          ))}
        </div>

      </Paper>
    );
  }
}

AlunoRestricaoCard.propTypes = {
  nome: PropTypes.string.isRequired,
  idade: PropTypes.number.isRequired,
  presente: PropTypes.bool,
  foto: PropTypes.string.isRequired,
  restricoes: PropTypes.array.isRequired,
  onClick: PropTypes.func
};

export default withStyles(styles)(AlunoRestricaoCard);